module.exports = __webpack_public_path__ + "img/Icon metro-rocket.18875b05.svg";